import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import Dashboard from '../../../components/DashBoard/DashBoard';
import Paragraph from '../../../components/Typography/Paragraph/Paragraph';
import RaceFilters from '../../UpcomingRacesView/RaceFilters/RaceFilters';
import { useAppSelector } from '../../../store/reducers';
import { pendingResults, raceResults } from '../../../store/selectors/resultsSelectors';
import Loader from '../../../components/Loader/Loader';
import useFilters from '../../../hooks/useFilters';
import { racesFilterConfig } from '../../UpcomingRacesView/RaceFilters/RaceFiltersConfig';
import ResultsCard from '../ResultsCard/ResultsCard';
import styles from './RaceResultsList.module.scss';
import { useNavigate } from 'react-router-dom';
import { Routes as RoutesEnum } from '../../../constants/routes';
const RaceResultsList = ({ filters }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isConnected } = useAppSelector(({ wallet }) => wallet.activeWallet);
    const pending = useSelector(pendingResults);
    const results = useSelector(raceResults);
    const filteredResultsList = useFilters(results, racesFilterConfig);
    const handleResultClick = (raceDetails) => {
        navigate(`${RoutesEnum.RESULTS}/${raceDetails.id}`);
    };
    return (_jsx(Dashboard, Object.assign({ className: styles.raceView }, { children: _jsxs("div", Object.assign({ className: cn('d-flex') }, { children: [_jsx(RaceFilters, { filter: filters }), _jsx("div", Object.assign({ className: styles.cardsBox }, { children: pending || !isConnected ? (_jsx(Loader, { className: cn('d-flex align-items-start', styles.loader) })) : (filteredResultsList === null || filteredResultsList === void 0 ? void 0 : filteredResultsList.length) !== 0 ? (_jsx(ResultsCard, { result: filteredResultsList, filters: filters, onResultClick: handleResultClick })) : (_jsx(Paragraph, { title: t('no_results') })) }))] })) })));
};
export default RaceResultsList;
